import { Modal } from "@arco-design/web-react";

// Shared "commit guard" for the always-editable form pattern. Editing is always
// frictionless; the only friction is at Save, and only when the thing being
// edited is live / getting traffic. Each editor decides what "live" means and
// supplies a human reason.
//
// Returns a promise resolving to true when it's safe to proceed (not live, or
// the user confirmed) and false when the user backs out.
//
//   const ok = await confirmIfLive({ live, title, content });
//   if (!ok) return;
//   doSave();
export function confirmIfLive({ live, title, content, okText = "Save changes" }) {
  if (!live) return Promise.resolve(true);
  return new Promise((resolve) => {
    Modal.confirm({
      title,
      content,
      okText,
      cancelText: "Keep editing",
      okButtonProps: { status: "warning" },
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}
